import { useQuery } from '@tanstack/react-query';
import { tasksApi } from '../api';
import { TaskItem } from '@demind-inc/core';
import { TaskFilterOptions } from '../types';
import { TASK_FILTER_ALL_LABEL_KEY } from '../constants';

interface FetchOverdueTasksParams {
  visibleProjectIds: string[];
  dueDateTill: string;
  limit: number;
  filter?: Pick<TaskFilterOptions, 'labelNames' | 'hideNoDueDate' | 'onlyMyTask'>;
}

export const OVERDUE_TASKS_PAGE_SIZE = 50;

export const useOverdueTasks = ({
  visibleProjectIds,
  dueDateTill,
  limit,
  filter,
}: FetchOverdueTasksParams) => {
  return useQuery({
    queryKey: ['lifestack.todo.overdueTasks', { visibleProjectIds, dueDateTill, limit, filter }],
    queryFn: () => {
      const transformedLabelNames =
        filter?.labelNames === undefined
          ? undefined
          : filter?.labelNames === TASK_FILTER_ALL_LABEL_KEY
            ? undefined
            : filter?.labelNames.join(',');

      return tasksApi
        .getOverdueTodoTasks(
          visibleProjectIds,
          dueDateTill,
          undefined,
          transformedLabelNames,
          false,
          filter?.onlyMyTask,
          filter?.hideNoDueDate,
          limit,
          true
        )
        .then(({ data }) => data as TaskItem[]);
    },
    refetchOnWindowFocus: visibleProjectIds?.length > 0 && !!dueDateTill,
    enabled: visibleProjectIds?.length > 0 && !!dueDateTill,
    staleTime: 15000, // 15s
  });
};
